
wizardSteps["conflict"] = {
    templateName: "#wizardStepConflictTemplate",
    beforeRender: function (ctx) {
        ctx.model.collisions = window.currentResponse.data;
        ctx.model.isCollisionWithPackage = ctx.model.collisions.find(function (occurrence) {
            return occurrence.Appointment.Type === "Package";
            }) !== undefined;
        ctx.model.isSeries = !!ctx.model.o.series;
    },
    afterPreparation: function (ctx) {
    },
    afterRender: function (ctx) {
        ctx.$el.find('.m-modal__step--conflict button')
            .click(function() {
                var $this = $(this);
                var solution = $this.attr('data-solution');
                ModalSave(solution, $("#m-modal__step--conflict-participants-message").val());
            });
    },
    getButtonList: function () {
        return {};
    }
};
